export type PowerField =
  | SensorAggregateField.POWER
  | SensorAggregateField.POWER_1
  | SensorAggregateField.POWER_2
  | SensorAggregateField.POWER_3

export type VoltageField =
  | SensorAggregateField.VOLTAGE_1
  | SensorAggregateField.VOLTAGE_2
  | SensorAggregateField.VOLTAGE_3

export type CurrentField =
  | SensorAggregateField.CURRENT_1
  | SensorAggregateField.CURRENT_2
  | SensorAggregateField.CURRENT_3

export type FrequencyField =
  | SensorAggregateField.FREQUENCY_FACTOR_1
  | SensorAggregateField.FREQUENCY_FACTOR_2
  | SensorAggregateField.FREQUENCY_FACTOR_3

export type PowerFactorField =
  | SensorAggregateField.POWER_FACTOR_1
  | SensorAggregateField.POWER_FACTOR_2
  | SensorAggregateField.POWER_FACTOR_3

export enum SensorAggregateField {
  CURRENT_1 = 'current_1',
  CURRENT_2 = 'current_2',
  CURRENT_3 = 'current_3',
  VOLTAGE_1 = 'voltage_1',
  VOLTAGE_2 = 'voltage_2',
  VOLTAGE_3 = 'voltage_3',
  /** @deprecated */
  KW = 'kw',
  /** @deprecated */
  KW_L1 = 'kw_l1',
  /** @deprecated */
  KW_L2 = 'kw_l2',
  /** @deprecated */
  KW_L3 = 'kw_l3',

  POWER = 'power',
  POWER_1 = 'power_1',
  POWER_2 = 'power_2',
  POWER_3 = 'power_3',
  POWER_FACTOR_1 = 'power_factor_1',
  POWER_FACTOR_2 = 'power_factor_2',
  POWER_FACTOR_3 = 'power_factor_3',
  FREQUENCY_FACTOR_1 = 'frequency_factor_1',
  FREQUENCY_FACTOR_2 = 'frequency_factor_2',
  FREQUENCY_FACTOR_3 = 'frequency_factor_3',
  TEMP = 'temp',
  RH = 'rh',
  RATED_CURRENT = 'rated_current',
  RSSI = 'rssi',
  ENERGY_COUNTER = 'energy_counter',
  EMISSION_FACTOR = 'emission_factor',
  ENERGY_PRICE = 'energy_price',
  ENERGY_SPOT_PRICE = 'energy_spot_price',
  ENERGY_DISTRIBUTION_PRICE = 'energy_distribution_price',
  WEATHER_TEMPERATURE = 'weather_temperature',
  WEATHER_HUMIDITY = 'weather_humidity',
  WEATHER_PRESSURE = 'weather_pressure',
  WEATHER_WIND_SPEED = 'weather_wind_speed',
  WEATHER_FEELS_LIKE_TEMPERATURE = 'weather_feels_like_temperature',
  ATTACHED_TEMPERATURE = 'attached_temperature',
  ATTACHED_PRESSURE = 'attached_pressure',
  ATTACHED_HUMIDITY = 'attached_humidity',
  PROJECT_OUTSIDE_TEMPERATURE = 'project_outside_temperature',
  PROJECT_OUTSIDE_HUMIDITY = 'project_outside_humidity',
  PROJECT_OUTSIDE_PRESSURE = 'project_outside_pressure'
}

export default SensorAggregateField
